<script setup lang="ts">
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { ContextAccess } from '@shared/Root/Context.access';
    import { inject } from 'vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const contextAccess: ContextAccess = injectorAccess.injector.get(ContextAccess);
</script>

<template>
    <div class="alert alert-danger alert-fixed-i" v-if="contextAccess.state.currentUser && !contextAccess.state.currentUser.EmailIsValidated">
        <p>
            <i class="fa fa-ban" aria-hidden="true"></i>
            <strong>{{ $Resources.AccountEmailValidatedheading }}</strong>
            <span v-html="$Resources.AccountEmailValidatedBody.replace('{{Email}}', contextAccess.state.currentUser.Email)"></span>
        </p>
        <div class="form-group d-flex gap-sm flex-wrap">
            <button type="button" class="btn btn-danger btn-xs" @click="contextAccess.reloadUserAndCheckUserEmailValidation">
                {{ $Resources.AccountEmailValidatedContinueButton }}
            </button>
            <button type="button" class="btn btn-subtle btn-xs" @click="contextAccess.sendValidation">{{ $Resources.AccountEmailValidatedButton }}</button>
        </div>
    </div>
</template>

<style scoped></style>
